// =============================================================================
// WORKFLOW .JSON — Format d'export/import de workflow canvas (issue #41, RFC #34)
// JSON structuré "ComfyUI-like" : représente un canvas complet (slots,
// blocs, wires) avec la bibliothèque de prompts embarquée pour être autosuffisant.
// =============================================================================

import type { Block, Wire, ProjectPrompt } from './index';

export const WORKFLOW_FORMAT = 'rabbit-prompt-workflow' as const;
export const WORKFLOW_VERSION = '1.0' as const;

export interface WorkflowMetadata {
  name: string;
  description?: string;
  // Date d'export en ISO 8601 (chaîne, sérialisable JSON)
  createdAt: string;
}

export interface PromptWorkflow {
  version: string;
  format: typeof WORKFLOW_FORMAT;
  metadata: WorkflowMetadata;
  blocks: Block[];
  wires: Wire[];
  // Prompts candidates de toutes les catégories présentes sur le canvas,
  // dénormalisées (ProjectPrompt) pour que le fichier soit importable sans
  // accès réseau. Toutes les candidates, pas seulement les sélections (#45).
  prompts: ProjectPrompt[];
}
